import pino from "pino";

export const logger = pino({
  timestamp: pino.stdTimeFunctions.isoTime,
});
